import './WelcomeVideoCreate.sass';

import React, { FC, useCallback, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Block, Button, Markdown } from '$uikit';
import { IcClose28, IcVerified16 } from '$assets';
import { useCurrentUserInfo, useTranslator, useUnitName } from '$hooks';
import { AttachPickerManagerRef } from '$shared/components/AttachPickerManager/AttachPickerManager.interface';
import AttachPickerManager from '$shared/components/AttachPickerManager/AttachPickerManager';
import { profileActions, profileSelector } from '$store/profile';
import { toastActions } from '$store/toast';
import { classNames as cn } from '$utils';

export const WelcomeVideoCreate: FC = (props) => {
  const t = useTranslator();
  const user = useCurrentUserInfo();
  const { welcomeVideoEdit, profileInfo, userId } = useSelector(profileSelector);
  const welcomeVideo = profileInfo[userId].welcomeVideo;
  const [videoInputKey, setVideoInputKey] = useState(0);
  const name = useUnitName(user, null, 'firstName');
  const dispatch = useDispatch();
  const attachManager = useRef<AttachPickerManagerRef | null>(null);

  const handleVideoSave = useCallback(() => {
    dispatch(toastActions.setToastLoading());
    dispatch(profileActions.uploadWelcomeVideo());
  }, []);

  const handleVideoChange = useCallback(
    ({ target: { files } }: React.ChangeEvent<HTMLInputElement>) => {
      if (!files) return;
      attachManager.current?.uploadVideo(files[0]);
      setVideoInputKey(Date.now());
    },
    [attachManager],
  );
  const completeEditHandler = useCallback(() => {
    dispatch(profileActions.setWelcomeVideoEdit(false));
  }, [attachManager]);

  const handleDeleteVideo = useCallback(() => {
    dispatch(profileActions.requestDeleteWelcomeVideo());
  }, [attachManager]);

  return (
    <Block className="WelcomeVideoCreate">
      <div className="WelcomeVideoCreate__header" onClick={console.log}>
        <div className="WelcomeVideoCreate__title">
          <IcVerified16 />
          {t('welcome_video_title')}
        </div>
        {welcomeVideoEdit && (
          <div
            onClick={completeEditHandler}
            className={cn('WelcomeVideoCreate__iconButton', { hidden: true })}
          >
            <IcClose28 />
          </div>
        )}
      </div>
      <div className="WelcomeVideoCreate__text">
        <Markdown>{t('welcome_video_create_text')}</Markdown>
      </div>
      <div className="WelcomeVideoCreate__example">
        {t('welcome_video_create_example', { name })}
      </div>
      <div className="WelcomeVideoCreate__buttons">
        <div className="WelcomeVideoCreate__button WelcomeVideoCreate__uploadButton">
          <AttachPickerManager
            hidden={true}
            watermark={false}
            onChange={handleVideoSave}
            ref={attachManager}
            pickerId={'welcome_video'}
          />
          <input
            key={videoInputKey}
            type="file"
            accept="video/*"
            onChange={handleVideoChange}
          />
          <Button>{t('welcome_video_create_upload_button')}</Button>
        </div>
        {!!welcomeVideo && (
          <div className="WelcomeVideoCreate__button">
            <Button mode="destructive" onClick={handleDeleteVideo}>
              {t('welcome_video_create_delete_button')}
            </Button>
          </div>
        )}
      </div>
    </Block>
  );
};
